import { createContext } from 'react';

const AdminContext = createContext<number>(1);
export default AdminContext;
